import { render, staticRenderFns } from "./CartRecapPage.vue?vue&type=template&id=39d73a0f"
import script from "./CartRecapPage.vue?vue&type=script&lang=js"
export * from "./CartRecapPage.vue?vue&type=script&lang=js"
import style0 from "./CartRecapPage.vue?vue&type=style&index=0&id=39d73a0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports